(function () {
    'use strict';

    angular
        .module('recommendationModule')
        .controller('SelectRecommendationController', Controller);

    Controller.$inject = ['$scope', 'searchService'];

    function Controller($scope, searchService) {
        $scope.ctxSelectRecommendation = {};

        $scope.searchRecommendations = function () {
            var searchTerm = $scope.ctxSelectRecommendation.searchTerm;

            if (_.isUndefined(searchTerm) || searchTerm.length < 2) {
                $scope.availableRecommendations = [];
                return;
            }

            searchService
                .searchRecommendations(searchTerm)
                .then(function (foundRecommendations) {
                    var availableRecomms = foundRecommendations.Results;

                    if ($scope.recomsForObservation) {
                        availableRecomms = _.reject(availableRecomms, function (recom) {

                            return _.some($scope.recomsForObservation, { RecommendationID: recom.RecommendationID });
                        });
                    }

                    $scope.availableRecommendations = availableRecomms;
                });
        }
    }
})();